import styles from './style.module.css'
import { fetchLogo } from './fetchLogo'

export function renderAuraSplash(){

    const element = document.createElement('div')
    element.classList = styles.splash
    fetchLogo()
        .then( url => {
            element.innerHTML = `<img src="${url}" />`
        } )
        .finally(() => {
            if ( element.querySelector('img') ) element.querySelector('img').classList = styles.img
        })
  
    if ( document.getElementById('root') ) document.getElementById('root').appendChild(element)
  }